import * as React from "react"
export const Svg_014 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={58}
    height={59}
    fill="none"
  >
    <path fill="url(#a)" d="M37.691 39.623h9.246v3.457H37.69v-3.457Z" />
    <path
      fill="url(#b)"
      d="M0 53.45h58V26.292H0v27.16Zm50.335-17.284v10.37H34.293v-10.37h16.042Z"
    />
    <path fill="url(#c)" d="M11.063 19.378h35.874v3.456H11.063v-3.456Z" />
    <path
      fill="url(#d)"
      d="M7.665 15.92h42.67v6.914H58V9.006H18.999L15.6 5.55H0v17.285h7.665V15.92Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={39.829}
        x2={40.635}
        y1={40.141}
        y2={43.627}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={13.412}
        x2={21.115}
        y1={30.365}
        y2={56.987}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={19.359}
        x2={19.577}
        y1={19.896}
        y2={23.555}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={13.412}
        x2={16.683}
        y1={8.142}
        y2={25.901}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)